import { createFileRoute } from "@tanstack/react-router";
import { AddPlaceView } from "@/lib/features/admin/AddPlaceView";
export const Route = createFileRoute("/_app/admin/lagg-till-plats")({
  component: AddPlaceView
});